import { take, map } from 'ramda';

import API from 'app/api';
import { deviceType } from 'config/baseconfig';
import parseResponse from 'app/api/requests/parsers/response';
import { Manga } from 'app/api/entities/manga';

const limit = 4;
const constantParams = {
  content_type: 'jp_manga',
  sort: 'popular',
};

const fetchMangas = () =>
  API.Manga.fetchMangaSeries({ device_type: deviceType, ...constantParams })
    .then(parseResponse)
    .then(take(limit))
    .then(map(Manga));

export { fetchMangas, constantParams };
